module.exports = __webpack_public_path__ + "img/WANING_GIBBOUS.131f06cb.png";